class ZafariCollection {
  constructor(root) {
    this.root = root;
    this.dialog = root.querySelector('[data-z-filter-dialog]');
    this.openButton = root.querySelector('[data-z-filter-open]');
    this.lastFocus = null;
    this.bindFilterDialog();
    this.bindSort();
  }

  bindFilterDialog() {
    if (!this.dialog || !this.openButton) return;
    this.openButton.addEventListener('click', () => {
      this.lastFocus = this.openButton;
      this.openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('z-filter-open');
      this.dialog.showModal();
      const firstControl = this.dialog.querySelector('[data-z-filter-close], input:not([disabled]), select, a[href], button');
      if (firstControl) firstControl.focus();
    });
    this.dialog.querySelectorAll('[data-z-filter-close]').forEach((button) => button.addEventListener('click', () => this.dialog.close()));
    this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) this.dialog.close(); });
    this.dialog.addEventListener('close', () => {
      document.body.classList.remove('z-filter-open');
      this.openButton.setAttribute('aria-expanded', 'false');
      if (this.lastFocus) this.lastFocus.focus();
      this.lastFocus = null;
    });
  }

  bindSort() {
    const form = this.root.querySelector('[data-z-sort-form]');
    const select = form && form.querySelector('[data-z-sort-select]');
    if (select) select.addEventListener('change', () => form.requestSubmit());
  }
}

const initZafariCollections = (scope = document) => scope.querySelectorAll('[data-z-collection]').forEach((root) => {
  if (!root.zafariCollection) root.zafariCollection = new ZafariCollection(root);
});

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initZafariCollections());
else initZafariCollections();
document.addEventListener('shopify:section:load', (event) => initZafariCollections(event.target));
